import React from 'react';
import { ReactComponent as Logo } from 'assets/KERV-Logos-Color-Application_K-Symbol.svg';

import './KervLogo.scss';

const KervLogo = () => {
  return (
    <>
      <div className='kerv-logo-container'>
        <a href='https://kerv.ai' target='_blank' rel="noopener noreferrer">
          <Logo className='kerv-logo'/>
        </a>
      </div>
    </>   
  );
}

export default KervLogo;
